// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1dbWr","addWidgetButton":"Header_addWidgetButton__3KdBp","dashboardTabs":"Header_dashboardTabs__1zlpl","active":"Header_active__NQd5s"};